import Grid from '@mui/material/Grid';
import React from 'react';
import ContentField from './ContentField';

export interface IWidgetMultiFields {
  values: any;
  classes: any;
  handleChange: any;
  setFieldValue: any;
}

export default function WidgetMultiFields(props: IWidgetMultiFields) {
  const {values, classes, handleChange} = props;

  return (
    <Grid key={`widgetsMulti`} container direction="column" style={{ marginBottom: 12 }}>

      <ContentField
        sx={classes.input}
        key={`widgetsMulti.title`}
        id={`widgetsMulti.title`}
        name={`widgetsMulti.title`}
        label="Multiple Widget Title"
        helperText={`For multiple widgets, what do we want to say? ${values.widgetsMulti?.title?.length}/90`}
        error={values.widgetsMulti && values.widgetsMulti?.title?.length > 150}
        defaultValue={values.widgetsMulti?.title}
        onBlur={handleChange}
        variant="outlined"
        validation={{}}
        touched={true}
        multiline
      />

      <ContentField
        sx={classes.input}
        key={`widgetsMulti.text`}
        id={`widgetsMulti.text`}
        name={`widgetsMulti.text`}
        label="Multiple Widget Text"
        helperText={`For multiple widgets, what do we want to say? ${values.widgetsMulti?.text?.length}/150`}
        error={values.widgetsMulti && values.widgetsMulti?.text?.length > 150}
        defaultValue={values.widgetsMulti?.text}
        onBlur={handleChange}
        variant="outlined"
        validation={{}}
        touched={true}
        multiline
      />
      <ContentField
        sx={classes.input}
        key={`widgetsMulti.action`}
        id={`widgetsMulti.action`}
        name={`widgetsMulti.action`}
        label="Multiple Widget Action"
        helperText={`For multiple widgets, what do you want to put on the button? ${values.widgetsMulti?.action?.length}/120`}
        error={values.widgetsMulti && values.widgetsMulti?.action?.length > 120}
        defaultValue={values.widgetsMulti?.action}
        onBlur={handleChange}
        variant="outlined"
        validation={{}}
        touched={true}
      />
    </Grid>
  )
}
